export default __webpack_public_path__ + "images/d2c08bf36eb8f43501d2dc3248d26536.svg";